import join from 'lodash/join';
import reduce from 'lodash/reduce';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { getTypedKeys } from '@atlassian/jira-shared-types/src/narrowing.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { PolarisQuery } from '../types.tsx';

const createQueryStringPostfixLegacy = (
	query: PolarisQuery,
	keysToDrop?: (keyof PolarisQuery)[],
): string => {
	// @ts-expect-error - TS2769 - No overload matches this call.
	const paramsList: string[] = reduce(
		query,
		(agg, val, key: keyof PolarisQuery) => {
			if (val === undefined || (keysToDrop && keysToDrop.includes(key))) {
				return agg;
			}
			return [...agg, `${key}=${val}`] as const;
		},
		[],
	);

	if (paramsList.length === 0) {
		return '';
	}

	const flatGetParams = join(paramsList, '&');

	return `?${flatGetParams}`;
};

const createQueryStringPostfixNext = (
	query: PolarisQuery,
	keysToDrop?: (keyof PolarisQuery)[],
): string => {
	const paramsList = getTypedKeys(query).reduce<string[]>((acc, key) => {
		const val = query[key];
		if (val === undefined || (keysToDrop && keysToDrop.includes(key))) {
			return acc;
		}
		acc.push(`${key}=${val}`);
		return acc;
	}, []);

	if (paramsList.length === 0) {
		return '';
	}

	const flatGetParams = paramsList.join('&');

	return `?${flatGetParams}`;
};

export const createQueryStringPostfix = functionWithCondition(
	() => fg('polaris_perf_improvements_spread_acc_lru_cache'),
	createQueryStringPostfixNext,
	createQueryStringPostfixLegacy,
);
